// M12 等差數列與等比數列 - 主題 11-20 數據文件
// Topics 11-20: 決策分析, 具體項計算, 固定額比較, 延伸求和, 指數計算, 累計折舊, 通項公式, 通項公式推導, 通項公式應用, 通項與和關係

// M12_11: 決策分析 (5題)
export const M12_11_PROBLEMS = [
  {
    id: 'M12_11_P001',
    topicId: 'M12_11',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '投資決策分析：兩種投資方案的比較',
    parts: {
      a: '方案A：首年收益10萬，每年遞增2萬',
      b: '方案B：首年收益5萬，每年按20%遞增',
      c: '哪種方案10年總收益更高？'
    },
    solution: {
      a: '方案A為等差數列：a₁ = 10, d = 2\\n第n年收益：aₙ = 10 + (n-1)×2 = 8 + 2n\\n10年總收益：S₁₀ = 10×10 + (10×9/2)×2 = 100 + 90 = 190萬',
      b: '方案B為等比數列：a₁ = 5, r = 1.2\\n第n年收益：aₙ = 5×(1.2)ⁿ⁻¹\\n10年總收益：S₁₀ = 5×(1.2¹⁰-1)/(1.2-1) = 5×(6.1917-1)/0.2 ≈ 129.6萬',
      c: '比較：方案A總收益190萬 > 方案B總收益129.6萬\\n因此方案A更優，多收益約60.4萬'
    },
    hint: {
      a: '識別等差數列，用求和公式',
      b: '識別等比數列，用求和公式',
      c: '比較兩個總和的大小'
    },
    tags: ['決策分析', '等差數列', '等比數列', '應用題'],
    difficulty: 4,
    order: 1
  },
  {
    id: 'M12_11_P002',
    topicId: 'M12_11',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '人員配置決策：兩種招聘策略',
    parts: {
      a: '策略1：每月固定招聘10人',
      b: '策略2：首月招聘2人，每月招聘人數翻倍',
      c: '12個月後哪種策略招聘總人數更多？'
    },
    solution: {
      a: '策略1為等差數列：aₙ = 10\\n12個月總招聘：S₁₂ = 12×10 = 120人',
      b: '策略2為等比數列：a₁ = 2, r = 2\\n第n月招聘：aₙ = 2×2ⁿ⁻¹ = 2ⁿ\\n12個月總招聘：S₁₂ = 2×(2¹²-1)/(2-1) = 2×(4096-1) = 8190人',
      c: '比較：策略2總人數8190人 >> 策略1總人數120人\\n策略2明顯更多，但需考慮實際可行性'
    },
    hint: {
      a: '等差數列求和',
      b: '等比數列求和',
      c: '考慮指數增長的威力'
    },
    tags: ['決策分析', '等比數列', '指數增長'],
    difficulty: 4,
    order: 2
  },
  {
    id: 'M12_11_P003',
    topicId: 'M12_11',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '生產計劃決策：兩種產量增長方案',
    parts: {
      a: '方案1：首月產量100件，每月增加50件',
      b: '方案2：首月產量80件，每月增長25%',
      c: '6個月後總產量哪個更高？'
    },
    solution: {
      a: '方案1：a₁ = 100, d = 50\\n6個月總產量：S₆ = 6×100 + (6×5/2)×50 = 600 + 750 = 1350件',
      b: '方案2：a₁ = 80, r = 1.25\\n6個月總產量：S₆ = 80×(1.25⁶-1)/(1.25-1) = 80×(3.8147-1)/0.25 ≈ 901.5件',
      c: '方案1總產量1350件 > 方案2總產量901.5件\\n方案1更優，多產448.5件'
    },
    hint: {
      a: '等差數列應用',
      b: '等比數列應用',
      c: '短期內線性增長優於指數增長'
    },
    tags: ['決策分析', '生產計劃', '數列比較'],
    difficulty: 4,
    order: 3
  },
  {
    id: 'M12_11_P004',
    topicId: 'M12_11',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '銷售策略決策：兩種獎金制度',
    parts: {
      a: '制度A：每月基本獎金5000元，每月遞增1000元',
      b: '制度B：首月獎金2000元，每月遞增50%',
      c: '8個月後哪種制度總獎金更高？'
    },
    solution: {
      a: '制度A：a₁ = 5000, d = 1000\\n8個月總獎金：S₈ = 8×5000 + (8×7/2)×1000 = 40000 + 28000 = 68000元',
      b: '制度B：a₁ = 2000, r = 1.5\\n8個月總獎金：S₈ = 2000×(1.5⁸-1)/(1.5-1) = 2000×(25.63-1)/0.5 = 98520元',
      c: '制度B總獎金98520元 > 制度A總獎金68000元\\n制度B更優，多獲得30520元'
    },
    hint: {
      a: '等差數列求和',
      b: '等比數列求和',
      c: '長期來看指數增長更有優勢'
    },
    tags: ['決策分析', '獎金制度', '數列應用'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_11_P005',
    topicId: 'M12_11',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '資源分配決策：兩種預算分配方案',
    parts: {
      a: '方案1：每季度預算固定200萬元',
      b: '方案2：首季度100萬元，每季度增長30%',
      c: '5年(20季度)後總預算哪個更合理？'
    },
    solution: {
      a: '方案1：每季度200萬\\n20季度總預算：S₂₀ = 20×200 = 4000萬元',
      b: '方案2：a₁ = 100, r = 1.3\\n20季度總預算：S₂₀ = 100×(1.3²⁰-1)/(1.3-1) = 100×(190.05-1)/0.3 ≈ 63016萬元',
      c: '方案2總預算63016萬元 >> 方案1總預算4000萬元\\n方案2預算過高，方案1更合理和可控'
    },
    hint: {
      a: '固定預算計算',
      b: '指數增長預算計算',
      c: '考慮預算的可持續性'
    },
    tags: ['決策分析', '預算管理', '可持續性'],
    difficulty: 4,
    order: 5
  }
];

// M12_12: 具體項計算 (5題)
export const M12_12_PROBLEMS = [
  {
    id: 'M12_12_P001',
    topicId: 'M12_12',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等差數列中特定項的計算：',
    parts: {
      a: '已知 a₁ = 3, d = 4，求 a₁₅',
      b: '已知 a₅ = 17, a₁₀ = 32，求 a₂₀',
      c: '驗證所求項是否正確'
    },
    solution: {
      a: '使用通項公式：aₙ = a₁ + (n-1)d\\na₁₅ = 3 + (15-1)×4 = 3 + 14×4 = 3 + 56 = 59',
      b: '先求公差：d = (a₁₀ - a₅)/(10-5) = (32-17)/5 = 3\\n求首項：a₁ = a₅ - 4d = 17 - 4×3 = 5\\na₂₀ = 5 + (20-1)×3 = 5 + 57 = 62',
      c: '驗證：a₁₅ = 59 正確\\na₂₀ = 62，檢驗：a₁₀ = 5 + 9×3 = 32 ✓'
    },
    hint: {
      a: '直接使用通項公式',
      b: '先求公差和首項',
      c: '用已知條件驗證'
    },
    tags: ['等差數列', '通項公式', '具體項'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_12_P002',
    topicId: 'M12_12',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等比數列中特定項的計算：',
    parts: {
      a: '已知 a₁ = 2, r = 3，求 a₈',
      b: '已知 a₃ = 12, a₆ = 96，求 a₉',
      c: '計算 a₁₀ 並驗證'
    },
    solution: {
      a: '使用通項公式：aₙ = a₁ × rⁿ⁻¹\\na₈ = 2 × 3⁸⁻¹ = 2 × 3⁷ = 2 × 2187 = 4374',
      b: '求公比：r³ = a₆/a₃ = 96/12 = 8，所以 r = 2\\n求首項：a₁ = a₃/r² = 12/4 = 3\\na₉ = 3 × 2⁸ = 3 × 256 = 768',
      c: 'a₁₀ = 3 × 2⁹ = 3 × 512 = 1536\\n驗證：a₆ = 3 × 2⁵ = 3 × 32 = 96 ✓'
    },
    hint: {
      a: '直接使用通項公式',
      b: '通過項的比值求公比',
      c: '用已知項驗證結果'
    },
    tags: ['等比數列', '通項公式', '具體項'],
    difficulty: 2,
    order: 2
  },
  {
    id: 'M12_12_P003',
    topicId: 'M12_12',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '混合數列中項的計算：',
    parts: {
      a: '數列 {aₙ}: a₁ = 1, aₙ₊₁ = 2aₙ + 3，求 a₅',
      b: '將此數列轉化為等比數列',
      c: '用等比數列公式驗證 a₅'
    },
    solution: {
      a: '逐項計算：\\na₁ = 1\\na₂ = 2×1 + 3 = 5\\na₃ = 2×5 + 3 = 13\\na₄ = 2×13 + 3 = 29\\na₅ = 2×29 + 3 = 61',
      b: '設 bₙ = aₙ + k，使 {bₙ} 成等比數列\\nbₙ₊₁ = aₙ₊₁ + k = 2aₙ + 3 + k = 2(bₙ - k) + 3 + k = 2bₙ - k + 3\\n要使比值為常數，需 -k + 3 = 0，即 k = 3\\n所以 bₙ = aₙ + 3 是等比數列，b₁ = 4, r = 2',
      c: 'bₙ = 4 × 2ⁿ⁻¹，所以 aₙ = 4 × 2ⁿ⁻¹ - 3\\na₅ = 4 × 2⁴ - 3 = 4 × 16 - 3 = 64 - 3 = 61 ✓'
    },
    hint: {
      a: '直接遞推計算',
      b: '尋找適當的變換',
      c: '用變換後的公式驗證'
    },
    tags: ['遞推數列', '等比變換', '通項公式'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_12_P004',
    topicId: 'M12_12',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '分段定義數列中項的計算：',
    parts: {
      a: 'aₙ = n² (n≤5), aₙ = 2ⁿ⁻⁵ × a₅ (n>5)，求 a₃, a₅',
      b: '求 a₈',
      c: '求 a₁₀ 並分析數列性質'
    },
    solution: {
      a: '當 n ≤ 5 時：aₙ = n²\\na₃ = 3² = 9\\na₅ = 5² = 25',
      b: '當 n > 5 時：aₙ = 2ⁿ⁻⁵ × a₅ = 2ⁿ⁻⁵ × 25\\na₈ = 2⁸⁻⁵ × 25 = 2³ × 25 = 8 × 25 = 200',
      c: 'a₁₀ = 2¹⁰⁻⁵ × 25 = 2⁵ × 25 = 32 × 25 = 800\\n分析：前5項按平方增長，後面項按指數增長，增長速度更快'
    },
    hint: {
      a: '使用第一段公式',
      b: '使用第二段公式',
      c: '注意分段函數的不同性質'
    },
    tags: ['分段數列', '平方數列', '指數數列'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_12_P005',
    topicId: 'M12_12',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複合數列中項的計算：',
    parts: {
      a: '已知 aₙ = 3 × 2ⁿ + (-1)ⁿ × n，求 a₁, a₂, a₃',
      b: '求 a₁₀',
      c: '分析奇偶項的規律'
    },
    solution: {
      a: 'a₁ = 3 × 2¹ + (-1)¹ × 1 = 6 - 1 = 5\\na₂ = 3 × 2² + (-1)² × 2 = 12 + 2 = 14\\na₃ = 3 × 2³ + (-1)³ × 3 = 24 - 3 = 21',
      b: 'a₁₀ = 3 × 2¹⁰ + (-1)¹⁰ × 10 = 3 × 1024 + 10 = 3072 + 10 = 3082',
      c: '奇數項：aₙ = 3 × 2ⁿ - n (n為奇數)\\n偶數項：aₙ = 3 × 2ⁿ + n (n為偶數)\\n主要部分 3×2ⁿ 呈指數增長，(-1)ⁿ×n 產生小幅振盪'
    },
    hint: {
      a: '注意 (-1)ⁿ 的符號變化',
      b: '分別計算兩部分',
      c: '按奇偶性分析規律'
    },
    tags: ['複合數列', '指數項', '交替項'],
    difficulty: 4,
    order: 5
  }
];

// M12_13: 固定額比較 (5題)
export const M12_13_PROBLEMS = [
  {
    id: 'M12_13_P001',
    topicId: 'M12_13',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等差數列中固定差額的比較：',
    parts: {
      a: '數列 {aₙ}: a₁ = 10, d = 3，比較 a₁₀ - a₅ 和 a₁₅ - a₁₀',
      b: '一般地，比較 aₘ₊ₖ - aₘ 和 aₙ₊ₖ - aₙ',
      c: '解釋等差數列中相同間隔項差的性質'
    },
    solution: {
      a: 'a₅ = 10 + 4×3 = 22, a₁₀ = 10 + 9×3 = 37, a₁₅ = 10 + 14×3 = 52\\na₁₀ - a₅ = 37 - 22 = 15\\na₁₅ - a₁₀ = 52 - 37 = 15\\n兩個差值相等',
      b: 'aₘ₊ₖ - aₘ = [a₁ + (m+k-1)d] - [a₁ + (m-1)d] = kd\\naₙ₊ₖ - aₙ = [a₁ + (n+k-1)d] - [a₁ + (n-1)d] = kd\\n所以 aₘ₊ₖ - aₘ = aₙ₊ₖ - aₙ = kd',
      c: '等差數列中，相同間隔的項差都相等，且等於間隔數乘以公差\\n這是等差數列的重要性質，體現了其線性特征'
    },
    hint: {
      a: '分別計算各項再求差',
      b: '用通項公式證明',
      c: '理解等差數列的線性性質'
    },
    tags: ['等差數列', '項差', '線性性質'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_13_P002',
    topicId: 'M12_13',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列中固定比值的比較：',
    parts: {
      a: '數列 {aₙ}: a₁ = 2, r = 3，比較 a₆/a₃ 和 a₉/a₆',
      b: '一般地，比較 aₘ₊ₖ/aₘ 和 aₙ₊ₖ/aₙ',
      c: '解釋等比數列中相同間隔項比的性質'
    },
    solution: {
      a: 'a₃ = 2×3² = 18, a₆ = 2×3⁵ = 486, a₉ = 2×3⁸ = 13122\\na₆/a₃ = 486/18 = 27 = 3³\\na₉/a₆ = 13122/486 = 27 = 3³\\n兩個比值相等',
      b: 'aₘ₊ₖ/aₘ = [a₁ × rᵐ⁺ᵏ⁻¹]/[a₁ × rᵐ⁻¹] = rᵏ\\naₙ₊ₖ/aₙ = [a₁ × rⁿ⁺ᵏ⁻¹]/[a₁ × rⁿ⁻¹] = rᵏ\\n所以 aₘ₊ₖ/aₘ = aₙ₊ₖ/aₙ = rᵏ',
      c: '等比數列中，相同間隔的項比都相等，且等於公比的間隔次方\\n這體現了等比數列的乘性結構特征'
    },
    hint: {
      a: '計算具體項再求比值',
      b: '用通項公式證明',
      c: '理解等比數列的乘性性質'
    },
    tags: ['等比數列', '項比', '乘性性質'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_13_P003',
    topicId: 'M12_13',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '數列增長率的固定比較：',
    parts: {
      a: '數列A: aₙ = 100 + 10n，數列B: bₙ = 50 × 1.2ⁿ',
      b: '比較第5項到第10項的增長量',
      c: '分析兩種增長模式的特點'
    },
    solution: {
      a: '數列A是等差數列：a₁ = 110, d = 10\\n數列B是等比數列：b₁ = 60, r = 1.2',
      b: '數列A：a₁₀ - a₅ = (100+100) - (100+50) = 50\\n數列B：b₁₀ - b₅ = 50×1.2¹⁰ - 50×1.2⁵ = 50×(6.192-2.488) = 185.2\\n數列B的增長量更大',
      c: '等差增長：固定增長量，線性增長\\n等比增長：增長量遞增，指數增長\\n短期內差異不大，長期內等比增長更快'
    },
    hint: {
      a: '識別數列類型',
      b: '計算對應區間的增長',
      c: '比較兩種增長模式'
    },
    tags: ['增長率', '等差數列', '等比數列'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_13_P004',
    topicId: 'M12_13',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複利與單利的固定額比較：',
    parts: {
      a: '本金10萬元，單利年利率8%，複利年利率6%',
      b: '比較第5年和第10年兩種方式的利息差額',
      c: '分析何時複利超過單利'
    },
    solution: {
      a: '單利：每年利息固定0.8萬元\\n複利：本息按1.06倍增長',
      b: '第5年：單利本息 = 10 + 5×0.8 = 14萬\\n複利本息 = 10×1.06⁵ = 13.38萬，差額 = 0.62萬\\n第10年：單利本息 = 10 + 10×0.8 = 18萬\\n複利本息 = 10×1.06¹⁰ = 17.91萬，差額 = 0.09萬',
      c: '設第n年複利超過單利：10×1.06ⁿ > 10 + 0.8n\\n1.06ⁿ > 1 + 0.08n\\n通過試算：n=12時，1.06¹² ≈ 2.01 > 1.96\\n所以第12年複利開始超過單利'
    },
    hint: {
      a: '理解單利和複利的計算方式',
      b: '分別計算兩個時點的數值',
      c: '建立不等式求解'
    },
    tags: ['單利', '複利', '金融應用'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_13_P005',
    topicId: 'M12_13',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '兩種儲蓄方案的固定額比較：',
    parts: {
      a: '方案1：每月存1000元，年利率3.6%',
      b: '方案2：首月存500元，每月遞增50元，年利率4.8%',
      c: '比較兩年後的總收益差額'
    },
    solution: {
      a: '方案1：等額存款，每月1000元\\n24個月總存款：24×1000 = 24000元\\n平均存款期限12.5個月，利息 ≈ 24000×3.6%×12.5/12 = 900元',
      b: '方案2：遞增存款，總存款 = 24×500 + (24×23/2)×50 = 12000 + 13800 = 25800元\\n加權平均利息計算較複雜，約 ≈ 25800×4.8%×12.5/12 = 1290元',
      c: '方案1總收益：24000 + 900 = 24900元\\n方案2總收益：25800 + 1290 = 27090元\\n方案2比方案1多收益2190元'
    },
    hint: {
      a: '等額存款計算',
      b: '遞增存款的總額計算',
      c: '考慮本金和利息的差異'
    },
    tags: ['儲蓄計劃', '等差數列', '利息計算'],
    difficulty: 4,
    order: 5
  }
];

// M12_14: 延伸求和 (5題)
export const M12_14_PROBLEMS = [
  {
    id: 'M12_14_P001',
    topicId: 'M12_14',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等差數列的延伸求和：',
    parts: {
      a: '求 1 + 3 + 5 + ... + (2n-1) 的和',
      b: '求 2 + 5 + 8 + ... + (3n-1) 的和',
      c: '驗證 n=10 時的結果'
    },
    solution: {
      a: '這是首項a₁=1，公差d=2的等差數列\\n第k項：aₖ = 2k-1，共n項\\nSₙ = n×(1 + 2n-1)/2 = n×2n/2 = n²',
      b: '這是首項a₁=2，公差d=3的等差數列\\n第k項：aₖ = 3k-1，共n項\\nSₙ = n×(2 + 3n-1)/2 = n×(3n+1)/2 = n(3n+1)/2',
      c: 'n=10時：\\n第一個和：S₁₀ = 10² = 100\\n第二個和：S₁₀ = 10×31/2 = 155\\n驗證：1+3+5+...+19 = 100 ✓，2+5+8+...+29 = 155 ✓'
    },
    hint: {
      a: '識別等差數列並用求和公式',
      b: '同樣方法處理',
      c: '代入具體值驗證'
    },
    tags: ['等差數列', '求和公式', '延伸應用'],
    difficulty: 3,
    order: 1
  },
  {
    id: 'M12_14_P002',
    topicId: 'M12_14',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列的延伸求和：',
    parts: {
      a: '求 1 + 2 + 4 + ... + 2ⁿ⁻¹ 的和',
      b: '求 3 + 6 + 12 + ... + 3×2ⁿ⁻¹ 的和',
      c: '計算當 n=8 時兩個和的值'
    },
    solution: {
      a: '這是首項a₁=1，公比r=2的等比數列，共n項\\nSₙ = 1×(2ⁿ-1)/(2-1) = 2ⁿ - 1',
      b: '這是首項a₁=3，公比r=2的等比數列，共n項\\nSₙ = 3×(2ⁿ-1)/(2-1) = 3(2ⁿ - 1)',
      c: 'n=8時：\\n第一個和：S₈ = 2⁸ - 1 = 256 - 1 = 255\\n第二個和：S₈ = 3×(256-1) = 3×255 = 765'
    },
    hint: {
      a: '識別等比數列特征',
      b: '注意首項的影響',
      c: '計算 2⁸ = 256'
    },
    tags: ['等比數列', '求和公式', '指數計算'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_14_P003',
    topicId: 'M12_14',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '分組求和的延伸應用：',
    parts: {
      a: '求 (1+2) + (3+4+5) + (6+7+8+9) + ... 前n組的和',
      b: '分析每組的項數和首項規律',
      c: '推導總和的通項公式'
    },
    solution: {
      a: '第k組有k個連續整數\\n第k組首項：1+1+2+...+(k-1) = 1 + k(k-1)/2\\n第k組和：k×[首項 + (k-1)/2] = k×[1 + k(k-1)/2 + (k-1)/2] = k(k²+1)/2',
      b: '第1組：1項，首項1，和=1\\n第2組：2項，首項3，和=7\\n第3組：3項，首項6，和=24\\n規律：第k組和 = k(k²+1)/2',
      c: '前n組總和：∑ₖ₌₁ⁿ k(k²+1)/2 = (1/2)∑ₖ₌₁ⁿ(k³+k)\\n= (1/2)[∑k³ + ∑k] = (1/2)[n²(n+1)²/4 + n(n+1)/2]\\n= n(n+1)(n²+n+2)/8'
    },
    hint: {
      a: '找出每組的規律',
      b: '分析項數和首項的變化',
      c: '使用立方和與平方和公式'
    },
    tags: ['分組求和', '立方和', '組合求和'],
    difficulty: 4,
    order: 3
  },
  {
    id: 'M12_14_P004',
    topicId: 'M12_14',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '交錯級數的延伸求和：',
    parts: {
      a: '求 1 - 2 + 3 - 4 + 5 - 6 + ... ± n 的和',
      b: '分n為奇數和偶數討論',
      c: '用另一種方法驗證結果'
    },
    solution: {
      a: '設Sₙ = 1 - 2 + 3 - 4 + ... ± n\\n按奇偶性分組：(1-2) + (3-4) + (5-6) + ...',
      b: '當n為偶數時：有n/2個(-1)組\\nSₙ = (-1) × n/2 = -n/2\\n當n為奇數時：有(n-1)/2個(-1)組，最後加上n\\nSₙ = (-1) × (n-1)/2 + n = (n+1)/2',
      c: '驗證方法：Sₙ = Sₙ₋₁ + (-1)ⁿ⁺¹ × n\\n或用公式：Sₙ = (-1)ⁿ⁺¹ × ⌈n/2⌉\\n結果一致：n偶數時Sₙ=-n/2，n奇數時Sₙ=(n+1)/2'
    },
    hint: {
      a: '觀察正負交替的規律',
      b: '按奇偶數分情況討論',
      c: '用遞推關係驗證'
    },
    tags: ['交錯級數', '奇偶討論', '分類求和'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_14_P005',
    topicId: 'M12_14',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複合數列的延伸求和：',
    parts: {
      a: '求 ∑ₖ₌₁ⁿ k × 2ᵏ 的和',
      b: '使用錯位相減法',
      c: '驗證 n=5 時的結果'
    },
    solution: {
      a: '設Sₙ = 1×2¹ + 2×2² + 3×2³ + ... + n×2ⁿ\\n這是等差數列與等比數列的乘積求和',
      b: '錯位相減法：\\nSₙ = 1×2 + 2×4 + 3×8 + ... + n×2ⁿ\\n2Sₙ = 1×4 + 2×8 + 3×16 + ... + n×2ⁿ⁺¹\\n相減：-Sₙ = 2 + 4 + 8 + ... + 2ⁿ - n×2ⁿ⁺¹\\n= 2(2ⁿ-1)/(2-1) - n×2ⁿ⁺¹ = 2ⁿ⁺¹ - 2 - n×2ⁿ⁺¹\\n所以 Sₙ = (n-1)×2ⁿ⁺¹ + 2',
      c: 'n=5時：S₅ = 4×2⁶ + 2 = 4×64 + 2 = 258\\n驗證：1×2 + 2×4 + 3×8 + 4×16 + 5×32 = 2+8+24+64+160 = 258 ✓'
    },
    hint: {
      a: '識別為等差×等比的形式',
      b: '使用錯位相減法',
      c: '直接計算驗證'
    },
    tags: ['錯位相減', '等差等比乘積', '複合求和'],
    difficulty: 4,
    order: 5
  }
];

// M12_15 到 M12_20 的數據將在其他文件中定義
// 導出所有題目數據
export const M12_TOPICS_11_20_PROBLEMS = [
  ...M12_11_PROBLEMS,
  ...M12_12_PROBLEMS,
  ...M12_13_PROBLEMS,
  ...M12_14_PROBLEMS,
  // M12_15 到 M12_20 將在 M12_Topics_15_to_20.js 中定義
];

// 主題信息
export const M12_TOPICS_11_20_INFO = [
  {
    id: 'M12_11',
    title: '決策分析',
    description: '運用數列知識進行投資和決策分析',
    difficulty: 'advanced',
    estimatedMinutes: 50,
    order: 11
  },
  {
    id: 'M12_12',
    title: '具體項計算',
    description: '計算數列中的特定項',
    difficulty: 'basic',
    estimatedMinutes: 30,
    order: 12
  },
  {
    id: 'M12_13',
    title: '固定額比較',
    description: '比較數列中固定間隔項的差值或比值',
    difficulty: 'intermediate',
    estimatedMinutes: 35,
    order: 13
  },
  {
    id: 'M12_14',
    title: '延伸求和',
    description: '各種複雜數列的求和方法',
    difficulty: 'advanced',
    estimatedMinutes: 45,
    order: 14
  }
]; 